(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elara-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('countdown-timer')) {
    customElements.define(
      'countdown-timer',
      class extends HTMLElement {
        connectedCallback() {
          this.endTime = new Date(this.dataset.end).getTime();
          this.cells = {
            days: this.querySelector('[data-unit="days"]'),
            hours: this.querySelector('[data-unit="hours"]'),
            minutes: this.querySelector('[data-unit="minutes"]'),
            seconds: this.querySelector('[data-unit="seconds"]'),
          };
          if (isNaN(this.endTime)) return;
          this.tick = this.tick.bind(this);
          this.tick();
          this.interval = setInterval(this.tick, 1000);
        }

        disconnectedCallback() {
          if (this.interval) clearInterval(this.interval);
        }

        tick() {
          var diff = Math.max(0, this.endTime - Date.now());
          var total = Math.floor(diff / 1000);
          this.write('days', Math.floor(total / 86400));
          this.write('hours', Math.floor((total % 86400) / 3600));
          this.write('minutes', Math.floor((total % 3600) / 60));
          this.write('seconds', total % 60);
          if (diff === 0 && this.interval) {
            clearInterval(this.interval);
            this.dispatchEvent(new CustomEvent('countdown:ended', { bubbles: true }));
          }
        }

        write(unit, value) {
          var el = this.cells[unit];
          if (el) el.textContent = String(value).padStart(2, '0');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
